/** Shared MUI theme constants — keep in sync with `src/scss/index.scss`. */

export const FONT_XS = 'var(--app-font-size-label)'
export const FONT_SM = 'var(--app-font-size-label)'
export const FONT_BASE = 'var(--app-font-size-body)'
export const FONT_MAX = 'var(--app-font-size-title)'
export const FONT_DISPLAY = 'var(--app-font-size-display)'
export const FONT_NANO = 'var(--app-font-size-label)'
export const FONT_SECTION_TITLE = 'var(--app-font-size-label)'
export const FONT_LEFT_NAV_BUTTON = 'var(--app-font-size-body)'
export const FONT_THOUGHT = 'var(--app-font-size-label)'
export const FONT_AGENT_RESULT = 'var(--app-font-size-body)'
export const LINE_HEIGHT_BASE = 'var(--app-line-height)'
export const LINE_HEIGHT_HEADING = 'var(--app-line-height)'
export const LINE_HEIGHT_TIGHT = 'var(--app-line-height)'
export const LINE_HEIGHT_AGENT = 'var(--app-line-height)'
export const FONT_WEIGHT_REGULAR = 'var(--app-font-weight-regular)'
export const FONT_WEIGHT_MEDIUM = 'var(--app-font-weight-medium)'

export const INK = {
  primary: 'rgba(43, 43, 43, 0.9)',
  secondary: 'rgba(43, 43, 43, 0.7)',
  tertiary: 'rgba(43, 43, 43, 0.5)',
  quaternary: 'rgba(43, 43, 43, 0.3)',
  disabled: 'rgba(43, 43, 43, 0.3)',
}
